


(function ($) {
  "use strict";
  $(function () {


    if ($('.js-template-promo').length) {



      if ($('.grid').length) {

        var $grid = $('.grid').imagesLoaded(function () {
          $('.grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: false,
          });
          calculateBgPush();
          $grid.on('layoutComplete', function () {
            calculateBgPush();
          });
        });
      }

      if ($('.js-scroll-to').length) {
        $(".js-scroll-to").on('click', function (e) {
          e.preventDefault();
          $('html,body').animate({
            scrollTop: $("#next").offset().top
          },
            'fast');
        });
      }

      if ($('.js-fit-title').length) {
        fitty('.js-fit-title', {
          minSize: 12,
          maxSize: 140
        });
      }

      objectFitImages();


      function calculateBgPush() {
        if ($('.js-bg-push').length) {
          var parent = $('.js-bg-push').parent();
          var index = parseInt($('.js-bg-push').data('index'));
          if (index > $('.js-bg-push').parent().find('.js-section').length) {
            index = $('.js-bg-push').parent().find('.js-section').length;
          }
          var secondSection = $('.js-bg-push').parent().find('.js-section').eq(index - 1);
          var topush = 0;
          if (secondSection.length == 0) {
            topush = 0;
          } else {
            topush = (secondSection.offset().top - parent.offset().top) + secondSection.outerHeight(true) / 2
          }

          $('.js-bg-push').css('top', topush + 'px').animate({ opacity: 1 });

        }
      }

      if ($('.grid').length == 0) {
        calculateBgPush();

        $(window).resize(function () {
          clearTimeout(window.resizedFinished);
          window.resizedFinished = setTimeout(function () {
            calculateBgPush();
          }, 250);
        });
      }


      /* LAX */


      var isIE = /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /Edge\/\d+/.test(navigator.userAgent);
      if (!isIE) {
        lax.init()

        // Setup mouse move listener
        document.addEventListener('mousemove', function (e) {
          lax.__cursorX = e.clientX
          lax.__cursorY = e.clientY

        }, false)

        // Add lax driver for cursorX
        lax.addDriver('cursorX', function () {
          return lax.__cursorX || 0
        })

        // Add lax driver for cursorY
        lax.addDriver('cursorY', function () {
          return lax.__cursorY || 0
        })

        // Add lax driver for cursorXY
        lax.addDriver('cursorDistanceFromCenter', function () {
          var pageHeight = document.body.scrollHeight
          var pageWidth = document.body.scrollWidth

          var pageCenterX = pageWidth / 2
          var pageCenterY = pageHeight / 2

          var absDistanceFromCenterY = Math.abs((lax.__cursorY || 0) - pageCenterY) / pageCenterY
          var absDistanceFromCenterX = Math.abs((lax.__cursorX || 0) - pageCenterX) / pageCenterX

          return absDistanceFromCenterX + absDistanceFromCenterY
        })

        // Add a driver that we use to control our animations
        lax.addDriver('scrollY', function () {
          return window.scrollY
        })

        if ($('.js-bg-title').length) {
          lax.addElements(".js-bg-title", {

            'cursorX': {
              "translateX": [
                [0, 'screenWidth'],
                [0, 200],
              ],
            }
            ,
            'cursorY': {
              "translateY": [
                [0, 'screenHeight'],
                [0, 50],
              ],
            },

          });
        }



        if ($('.js-swiper-anim').length) {
          lax.addElements('.js-swiper-anim', {
            scrollY: {
              translateX: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['elWidth/3', 0, '0'],
              ],

            }
          });
        }


        if ($('.js-decor-1').length) {
          // Add animation bindings to elements
          lax.addElements('.js-decor-1', {
            scrollY: {
              translateX: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['-elWidth', 0, '0'],
              ],

            }
          });

        }

        if ($('.js-decor-2').length) {
          lax.addElements('.js-decor-2', {
            scrollY: {

              rotate: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['elWidth', '0', '0'],
              ],
              translateX: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['elWidth', '0', '0'],
              ],
            }
          });
        }

        if ($('.js-decor-3').length) {
          lax.addElements('.js-decor-3', {
            scrollY: {
              perspective: [
                [0],
                [1000],
              ],

              translateY: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['-elWidth', '0', '0'],

              ],

            },
          })
        }

        if ($('.js-decor-4').length) {
          lax.addElements('.js-decor-4', {
            scrollY: {
              perspective: [
                [0],
                [1000],
              ],

              translateY: [
                ['elInY', 'elCenterY', 'elOutY'],
                ['elWidth', '0', '0'],

              ],

            },
          })

        }
      }


      if ($('.swiper-container').length) {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 30,
          centeredSlides: true,
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          initialSlide: 0,
          breakpoints: {

            1200: {
              initialSlide: 1,
            },

          }

        });
      }

    }

  });
})(jQuery);
